import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Categories() {
  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 text-xs font-medium bg-secondary-100 text-secondary-700 rounded-full mb-4">
            创作分类
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            探索你的AI美女创作方向
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto leading-relaxed">
            从写真到头像，从壁纸到虚拟角色，多种创作方向满足你的不同需求。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative rounded-2xl overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer h-[280px]"
            >
              <div className="absolute inset-0">
                <img
                  src={cat.imageUrl}
                  alt={cat.name}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/65 via-black/20 to-transparent"></div>
              </div>
              <div className="relative z-10 h-full flex flex-col justify-end p-6 md:p-8">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-white/20 backdrop-blur-sm text-white">
                    <i className={`${cat.icon} text-lg`}></i>
                  </div>
                  <span className="text-xs px-2.5 py-1 rounded-full bg-white/20 text-white/90">
                    {cat.count} 个作品
                  </span>
                </div>
                <h3 className="text-xl md:text-2xl font-heading font-bold text-white mb-2">
                  {cat.name}
                </h3>
                <p className="text-sm text-white/70 leading-relaxed max-w-md">
                  {cat.description}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}